
/* injects from baggage-loader */

'use strict';

export default class FooterController {
    constructor() {
        'ngInject';
        
    }

    $onInit() {
       
    }
}


// WEBPACK FOOTER //
// ./src/app/components/footer/footer.controller.js